import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Endpoints } from "../../Global/Endpoints";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

Modal.setAppElement("#root");

const MenopurModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const token = localStorage.getItem('AccessToken');
  const userInfo = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";


  const submitConsent = async (consent) => {
    try {
      const params = {
        Email: userInfo.userData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        memberID: userInfo.userData.MemberID,
        contract: userInfo.userData.ContractIdentified,
        MemberConsent: consent,
      };

      const response = await axios.post(
        Endpoints.UpdateMemberConsent,
        { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      if (response.data?.result === 1) {
        console.log(response.data.resultText);
        onClose(); 
      } else {
        console.log("Failed to save details:", response.data?.resultText);
      }
      onClose();
    } catch (error) {
      console.error("Error updating consent:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="tracker-modal-content" style={{content: {minHeight: "400px"}}} overlayClassName="modal-overlay">
      <div className="d-flex flex-column justify-content-btween align-items-center" style={{height: "360px"}}>
      <h2>Your Menopur WINCard is ready for use.</h2>
      <p className="text-sm text-gray-600 mt-5">
        Would you like us to notify the pharmacy and give them the card number?
      </p>

      <div className="d-flex flex-sm-row flex-column justify-content-center align-items-center align-text-bottom mt-auto" style={{width: "100%"}}>
        <button
          onClick={() => submitConsent("Y")}
          className="win-btn-primary mobile-view mt-2 mx-2"
        >
          Yes
        </button>
        <button
          onClick={() => submitConsent("N")}
          className="win-btn-secondary mobile-view mt-2 mx-2"
        >
          No
        </button>
      </div>
      </div>
    </Modal>
  );
};
export default MenopurModal;
